import { safeJsonParse } from '@/utils/jsonParse';

import { client } from '..';
import {
  CreateVolunteerEventResponse,
  CreateVolunteerParams,
  EditThumbnailVolunteerParams,
  EditVolunteerParams,
  VolunteerEvent,
  VolunteerEventsResponse
} from '../models/volunteerModels';

export const getVolunteerEventById = async ({ id }: { id: string }): Promise<VolunteerEvent> => {
  const url = `/volunteers/${id}`;
  const { data } = await client.get(url);

  return data[0];
};

export const getVolunteerEvents = async ({
  queryKey,
  pageParam
}: {
  queryKey: (string | number | undefined)[];
  pageParam: string | undefined;
}): Promise<VolunteerEventsResponse> => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, __, limit, npoId, latitude, longitude, ___] = queryKey;

  // With Location
  if (latitude && longitude) {
    // First fetch
    if (pageParam === '0') {
      const url = `/volunteers/scrolling?npo=${npoId ?? ''}&n=${pageParam}&limit=${limit ?? ''}&latitude=${latitude ?? ''}&longitude=${longitude ?? ''}`;
      const { data } = await client.get(url);

      return data;
    }

    const scrollParam = safeJsonParse<{ n: string; lastDistance: number }>(pageParam ?? '');
    const url = `/volunteers/scrolling?npo=${npoId ?? ''}&n=${scrollParam?.n}&lastDistance=${scrollParam?.lastDistance}&limit=${limit ?? ''}&latitude=${latitude ?? ''}&longitude=${longitude ?? ''}`;
    const { data } = await client.get(url);

    return data;
  }

  // Without Location
  const url = `/volunteers/scrolling?npo=${npoId ?? ''}&n=${pageParam}&limit=${limit ?? ''}`;
  const { data } = await client.get(url);

  return data;
};

export const createVolunteerEvent = async ({
  name,
  thumbnail,
  location,
  address,
  description,
  startDate,
  nonProfitOrgId,
  subtitle
}: CreateVolunteerParams): Promise<CreateVolunteerEventResponse> => {
  const url = '/volunteers';
  const { data } = await client.post(url, {
    name,
    thumbnail,
    location,
    address,
    description,
    startDate,
    nonProfitOrgId,
    subtitle
  });

  return data;
};

export const editVolunteerEvent = async ({
  volunteerId,
  body
}: {
  volunteerId: string;
  body: EditVolunteerParams | EditThumbnailVolunteerParams;
}): Promise<any> => {
  const url = `/volunteers/${volunteerId}`;

  const { data } = await client.patch(url, body);

  return data;
};

export const deleteVolunteerEvent = async ({ volunteerId }: { volunteerId: string }): Promise<any> => {
  const url = `/volunteers/${volunteerId}`;

  const { data } = await client.delete(url);

  return data;
};
